import timeDepositConstants from '../actiontypes/timeDeposit';

const initialState = {
  timeDeposit: {},
  list: []
};

function timeDeposit(state = initialState, action) {
  switch (action.type) {
    case timeDepositConstants.LIST_REQUEST:
      return { ...state };
    case timeDepositConstants.LIST_SUCCESS:
      return { ...state, list: action.payload };
    case timeDepositConstants.LIST_FAILURE:
      return { ...state, list: [] };
    case timeDepositConstants.TIME_DEPOSIT_REQUEST:
      return { ...state };
    case timeDepositConstants.TIME_DEPOSIT_SUCCESS:
      return { ...state, timeDeposit: action.payload };
    case timeDepositConstants.TIME_DEPOSIT_FAILURE:
      return { ...state, timeDeposit: {} };
    default:
      return state;
  }
}

export default timeDeposit;
